import { GroupedInstructionItem } from '@cue/data';

export function getNextAreaInfo(
  currentGroupIdx: number,
  groups: GroupedInstructionItem[]
): {
  newAreaId: number;
  newAreaGroupIdx: number;
} {
  let newAreaGroupIdx = currentGroupIdx;
  if (currentGroupIdx < groups.length - 1) {
    newAreaGroupIdx = currentGroupIdx + 1;
  }

  return {
    newAreaId: groups[newAreaGroupIdx].areaId,
    newAreaGroupIdx: newAreaGroupIdx,
  };
}

export function getFirstNavigationGroupOfArea(areaId: number, groups?: GroupedInstructionItem[]) {
  if (!groups) return 0;
  if (groups.length > 0) {
    return groups.findIndex((x) => x.areaId == areaId);
  } else {
    return 0;
  }
}

export function getFirstPreviousAreaOfCurrent(
  areaId: number,
  currentGroupIdx: number,
  groups: GroupedInstructionItem[]
) {
  const areaListWithIndexes = groups.map((x, index) => {
    return {
      idx: index,
      data: x,
    };
  });

  return areaListWithIndexes.slice(0, currentGroupIdx).find((x) => x.data.areaId === areaId)?.idx;
}

export function getFirstNextAreaOfCurrent(areaId: number, currentGroupIdx: number, groups: GroupedInstructionItem[]) {
  const areaListWithIndexes = groups.map((x, index) => {
    return {
      idx: index,
      data: x,
    };
  });

  return areaListWithIndexes.slice(currentGroupIdx + 1).find((x) => x.data.areaId === areaId)?.idx;
}
